import styled from 'styled-components';

export const BackgroundOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 45vh;
  background-color: #d8d9dc;
  z-index: -1;
`;

export const ContentContainer = styled.div`
  position: relative;
  gap: 12px;
  display: flex;
  flex-direction: column;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
`;

export const TitleForm = styled.h1`
  font-weight: 600;
  font-size: 20px;
  font-family: 'Open Sans';
  font-style: normal;
  line-height: normal;
`;
